import AuthorizationCodeCallbackView from "@/views/oauth2/AuthorizationCodeCallbackView";
import VerificationCodeCallbackView from "@/views/oauth2/VerificationCodeCallbackView";
import StartAuthorizationCodeView from "@/views/oauth2/StartAuthorizationCodeView";
import RestrictedView from "@/views/oauth2/RestrictedView";
import LogoutView from "@/views/oauth2/LogoutView";
import LoginView from "@/views/oauth2/LoginView";
import CreationUtilisateurView from "@/views/oauth2/CreationUtilisateurView";
import ModificationUtilisateurView from "@/views/oauth2/ModificationUtilisateurView";
import MotDePasseOublieView from "@/views/oauth2/MotDePasseOublieView";
import ReinitMotDePasseOublieView from "@/views/oauth2/ReinitMotDePasseOublieView";
import { authentified } from "./AccesDecisions";

export default [
  {
    path: "/oauth_callback",
    component: AuthorizationCodeCallbackView,
  },
  {
    path: "/restricted",
    name: "restricted",
    component: RestrictedView,
  },
  {
    path: "/logout",
    name: "logout",
    component: LogoutView,
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    props: true,
  },
  {
    path: "/startlogin",
    name: "startlogin",
    component: StartAuthorizationCodeView,
    props: true,
  },
  {
    path: "/utilisateur/creationcompte",
    name: "creationcompte",
    component: CreationUtilisateurView,
  },
  {
    path: "/utilisateur/jaioublie",
    name: "motpasseoublie",
    component: MotDePasseOublieView,
  },
  {
    path: "/utilisateur/finalisation",
    component: VerificationCodeCallbackView,
  },
  {
    path: "/utilisateur/motdepasseoublie",
    component: ReinitMotDePasseOublieView,
  },
  {
    path: "/utilisateur/modification",
    name: "modificationcompte",
    component: ModificationUtilisateurView,
    meta: {
      auth: authentified()
    }
  },
];
